import { FC } from 'react'
import { Action } from './types'
import { AppsLink } from '@wellesley/router'
import { Button } from '@wellesley/ui'
import { isJSXAction } from './helpers'

export type SideBarActionButtonProps = {
  action?: Action
  className?: string
  buttonClassName?: string
  defaultVariant?: 'primary' | 'secondary'
}
export const SideBarActionButton: FC<SideBarActionButtonProps> = ({
  action,
  className,
  buttonClassName,
  defaultVariant = 'primary',
}) => {
  if (!action) return null

  if (isJSXAction(action)) {
    return action
  }

  const { link, variant, onClick, disabled, Icon, name } = action
  return (
    <AppsLink to={link || ''} className={className}>
      <Button
        variant={variant || defaultVariant}
        size="m"
        className={buttonClassName}
        onClick={onClick}
        disabled={disabled}
      >
        {Icon && <Icon size={16} />}
        {name}
      </Button>
    </AppsLink>
  )
}
